import { assertBrowserEnvironmentBoundary } from './environmentBoundary'

function publicSimulationOrigin(value: string) {
  try {
    const url = new URL(value.trim())
    return url.protocol === 'https:' ? url.origin : 'https://avertsignal.com'
  } catch {
    return 'https://avertsignal.com'
  }
}

const environment = import.meta.env.VITE_AVERTSIGNAL_ENVIRONMENT || ''
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || ''
const workspaceId = import.meta.env.VITE_CRM_WORKSPACE_ID || ''
assertBrowserEnvironmentBoundary(environment, supabaseUrl, workspaceId)

export const config = {
  environment,
  supabaseUrl,
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY || '',
  workspaceId,
  publicSimulationOrigin: publicSimulationOrigin(import.meta.env.VITE_PUBLIC_SIMULATION_ORIGIN || 'https://avertsignal.com'),
  apiBase: import.meta.env.VITE_API_BASE || '/.netlify/functions',
  endpoints: {
    crmData: import.meta.env.VITE_CRM_DATA_ENDPOINT || '/crm-data',
    providerActions: import.meta.env.VITE_PROVIDER_ACTIONS_ENDPOINT || '/provider-actions',
    voiceToken: import.meta.env.VITE_VOICE_TOKEN_ENDPOINT || '/voice-token',
    voiceCallContext: import.meta.env.VITE_VOICE_CALL_CONTEXT_ENDPOINT || '/voice-call-context',
    voiceCallability: import.meta.env.VITE_VOICE_CALLABILITY_ENDPOINT || '/voice-callability',
    voiceQuickDial: import.meta.env.VITE_VOICE_QUICK_DIAL_ENDPOINT || '/voice-quick-dial',
    voiceCallAttach: import.meta.env.VITE_VOICE_CALL_ATTACH_ENDPOINT || '/voice-call-attach',
    voiceCallStatus: import.meta.env.VITE_VOICE_CALL_STATUS_ENDPOINT || '/voice-call-status',
    voiceWorkspace: import.meta.env.VITE_VOICE_WORKSPACE_ENDPOINT || '/voice-workspace',
    communicationsLive: import.meta.env.VITE_COMMUNICATIONS_LIVE_ENDPOINT || '/communications-live',
    leads: '/leads',
    crmMutations: import.meta.env.VITE_CRM_MUTATIONS_ENDPOINT || '/crm-mutations',
    collaboration: import.meta.env.VITE_COLLABORATION_ENDPOINT || '/collaboration',
    teamAccess: import.meta.env.VITE_TEAM_ACCESS_ENDPOINT || '/team-access',
    phoneAdmin: import.meta.env.VITE_PHONE_ADMIN_ENDPOINT || '/phone-admin',
    selfRecovery: '/crm-self-recovery',
    microsoftCommunications: import.meta.env.VITE_MICROSOFT_COMMUNICATIONS_ENDPOINT || '/microsoft-communications',
    microsoftActions: import.meta.env.VITE_MICROSOFT_ACTIONS_ENDPOINT || '/microsoft-actions',
    recordAssets: import.meta.env.VITE_RECORD_ASSETS_ENDPOINT || '/record-assets',
    emailDrafts: import.meta.env.VITE_EMAIL_DRAFTS_ENDPOINT || '/email-drafts',
    prospectDiscovery: import.meta.env.VITE_PROSPECT_DISCOVERY_ENDPOINT || '/prospect-discovery',
    demoCenter: import.meta.env.VITE_DEMO_CENTER_ENDPOINT || '/demo-center',
    founderControl: import.meta.env.VITE_FOUNDER_CONTROL_ENDPOINT || '/founder-control',
    salesRepAttribution: import.meta.env.VITE_SALES_REP_ATTRIBUTION_ENDPOINT || '/sales-rep-attribution',
  },
  features: {
    calling: false,
    sms: false,
    email: import.meta.env.VITE_ENABLE_EMAIL !== 'false',
    aiSummary: false,
  },
}

export const endpoint = (path: string) => `${config.apiBase}${path}`
